import { makeAPIRequest } from "./makeRequest";

export const TestConnection = (data: any) => {
    let config = {
        method: 'GET',
        url: process.env.REACT_APP_SERVER_URL + 'VehWizAPI/TestSFTPConnection?host=' + data.host + '&port=' + data.port + '&username=' + data.username + '&password=' + data.password,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }

    let res = makeAPIRequest(config);
    return res;
}